import { render } from "./DeleteProfileModal.vue?vue&type=template&id=a6763ab4"
import script from "./DeleteProfileModal.vue?vue&type=script&lang=js"
export * from "./DeleteProfileModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/TheIdFactory/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__